import { useMemo } from "react";

import * as COLUMNS_AVAILABLE from "b2b/components/produkty-grid-columns/columnsAvailable";

export default function useColumns() {
  const columns = [
    COLUMNS_AVAILABLE.nazev(),
    COLUMNS_AVAILABLE.popis(),
    COLUMNS_AVAILABLE.zkratka(),
    COLUMNS_AVAILABLE.uzivaNapajeni(),
    COLUMNS_AVAILABLE.vylucny(),
    COLUMNS_AVAILABLE.parkovani(),
    COLUMNS_AVAILABLE.bezCasu()
  ];
  return useMemo(() => [columns], []);
}
